import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ja from './locales/ja.json';
import th from './locales/th.json';
import zhTW from './locales/zh-TW.json';

// Clear existing language cache
localStorage.removeItem('i18nextLng');

// 폰트 동적 로드 함수
const loadFonts = (lang: string) => {
  // Silkscreen은 항상 로드 (기본 폰트)
  if (!document.querySelector('link[href*="Silkscreen"]')) {
    const silkscreen = document.createElement('link');
    silkscreen.href = 'https://fonts.googleapis.com/css2?family=Silkscreen:wght@400;700&display=swap';
    silkscreen.rel = 'stylesheet';
    document.head.appendChild(silkscreen);
  }

  // 언어별 폰트 조건부 로드
  switch (lang) {
    case 'ja':
      if (!document.querySelector('link[href*="DotGothic16"]')) {
        const dotGothic = document.createElement('link');
        dotGothic.href = 'https://fonts.googleapis.com/css2?family=DotGothic16&display=swap';
        dotGothic.rel = 'stylesheet';
        document.head.appendChild(dotGothic);
      }
      break;
    case 'zh-TW':
      if (!document.querySelector('link[href*="Noto+Sans+TC"]')) {
        const notoTC = document.createElement('link');
        notoTC.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;700&display=swap';
        notoTC.rel = 'stylesheet';
        document.head.appendChild(notoTC);
      }
      break;
    case 'th':
      if (!document.querySelector('link[href*="Kanit"]')) {
        const thai = document.createElement('link');
        thai.href = 'https://fonts.googleapis.com/css2?family=Kanit:wght@400;700&family=Sarabun:wght@400;700&display=swap';
        thai.rel = 'stylesheet';
        document.head.appendChild(thai);
      }
      break;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
      th: { translation: th },
      'zh-TW': { translation: zhTW },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'en-US', 'ja', 'th', 'zh-TW'],
    detection: {
      order: ['navigator'],
      caches: [], // Disable caching
    },
    interpolation: {
      escapeValue: false,
    },
  });

// HTML lang 속성 변경 및 폰트 로드 함수
const updateHtmlLang = (lng: string) => {
  document.documentElement.lang = lng;
  loadFonts(lng);
};

// 언어 변경 시 HTML lang 속성도 업데이트
i18n.on('languageChanged', updateHtmlLang);

// 초기 언어 설정 시에도 HTML lang 속성 설정
updateHtmlLang(i18n.language);

export const resetLanguage = () => {
  localStorage.removeItem('i18nextLng');
  const browserLang = navigator.language;
  i18n.changeLanguage(browserLang);
};

export default i18n;